import { render, staticRenderFns } from "./DuplicatePromo.vue?vue&type=template&id=085ac74b&scoped=true&"
import script from "./DuplicatePromo.vue?vue&type=script&lang=js&"
export * from "./DuplicatePromo.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePromo.vue?vue&type=style&index=0&id=085ac74b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ac74b",
  null
  
)

export default component.exports